<!--
 * @Description: 
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <!-- 这是支持行内编辑 -->
  <template v-if="opType == 1">
    <div class="upload-content">
      <template v-if="modulesItem?.fieldValue?.length && Array.isArray(modulesItem.fieldValue)">
        <ly-attachment-list :fieldValue="modulesItem.fieldValue" :all="false"></ly-attachment-list>
      </template>
      <jw-link class="upload-link" :disabled="modulesItem.businessData == '0' || disabledAll" @click="uploadCk">{{ t('请上传') }}</jw-link>
    </div>
  </template>
  <template v-else>
    <template v-if="isQuoteField">
      <template v-if="JSON.parse(modulesItem?.setting?.business?.fieldExt)?.uploadType == 2 && JSON.parse(modulesItem?.setting?.business?.fieldExt)?.fileType == 2">
        <fh-img-watermark :fileItem="modulesItem?.fieldValue" :fieldExt="modulesItem?.setting?.business?.fieldExt" :showRemoveBtn="false"></fh-img-watermark>
      </template>
      <template v-else>
        <template v-if="modulesItem?.fieldValue?.length && Array.isArray(modulesItem.fieldValue)">
          <div class="attachments-preview-list">
            <span class="attach-item" v-for="(item, index) of modulesItem?.fieldValue" :key="item?.url" @click.stop>
              <fh-attachment-preview :file-item="item" :show-video-cover="true" :icon-style="iconStyle" :index="index" :list="modulesItem?.fieldValue" />
            </span>
          </div>
        </template>
        <template v-else>
          <jw-input disabled class="system-form-item-fields ly-form-item-fields-disabled" placeholder="-" />
        </template>
      </template>
    </template>

    <template v-else-if="JSON.parse(modulesItem?.setting?.fieldExt)?.uploadType == 2 && JSON.parse(modulesItem?.setting?.fieldExt)?.fileType == 2">
      <fh-img-watermark :fileItem="modulesItem?.fieldValue" :fieldExt="modulesItem?.setting?.fieldExt" @cb="setModulesItem($event, modulesItem)"></fh-img-watermark>
    </template>
    <template v-else>
      <fh-attachment-upload :fieldExt="modulesItem?.setting?.fieldExt" v-model="modulesItem.fieldValue" :defaultFileList="modulesItem?.fieldValue" class="system-formlumns-item-value" @cb="setModulesItem($event, modulesItem)" :disabled="modulesItem.businessData == '0' || disabledAll" :show-remove-btn="modulesItem.businessData != '0' && !disabledAll" :key="modulesItem?.isRefresh" />
    </template>
  </template>

  <!-- 附件上传弹窗 -->
  <fh-upload-modal @cb="setModulesItem" ref="uploadModalRef" opType="1" />
</template>

<script setup>
import { ref, inject, watch } from 'vue';
import { useI18n } from 'vue-i18n';
const emits = defineEmits(['attachMentCb']);
const isQuoteField = inject('fhFormFieldsParams')?.isQuoteField;
const { t } = useI18n();
const props = defineProps({
  modules: {
    type: Object,
    default: () => {}
  },
  disabledAll: {
    type: Boolean,
    default: false
  },
  formatData: {
    type: Array,
    default: () => []
  },
  opType: {
    type: Number,
    default: 0
  }
});

const uploadModalRef = ref(null);

const modulesItem = ref(props?.modules);

// 行内编辑--上传附件
const uploadCk = () => {
  console.log('行内编辑上传', uploadModalRef.value);
  uploadModalRef.value?.openModal({ ...modulesItem.value, fieldExt: modulesItem.value?.setting?.fieldExt });
};

const setModulesItem = (ev) => {
  //附件
  emits('attachMentCb', ev);
};

watch(
  () => props.modules,
  (newVal) => {
    modulesItem.value = newVal;
  },
  {
    deep: true
  }
);
</script>

<style scoped lang="less">
@import './attachment.less';
</style>
